
import { mapState } from "vuex";

export default {
  async fetch() {
    if (this.shop.deliveryservice) {
      return;
    }

    await this.$store.dispatch("bag/fetchShopMetafields");
  },

  fetchOnServer: false,

  computed: {
    ...mapState("bag", ["shop"]),
  },
};
